import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;

  @media (max-width: 770px) {
    gap: 10px;
    margin-bottom: 0;
  }
`;

export const RadioLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #333333;

  @media (max-width: 770px) {
    font-size: 14px;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 770px) {
    gap: 16px;
  }
`;

export const RadioButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  input[type='radio'] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #000fff;
    margin: 0;
  }

  label {
    font-size: 16px;
    color: #808080;
    cursor: pointer;
    font-weight: 400;
    margin: 0;
    user-select: none;

    @media (max-width: 770px) {
      font-size: 14px;
    }
  }

  input[type='radio']:checked + label {
    color: #000fff;
    font-weight: 500;
  }
`;
